import StepGatingController from '../common/step_gating_controller'

// PC診断ウィジェット: ステップ順次活性化は共通ロジックをそのまま利用する
export default class extends StepGatingController {}
